import axiosLocal from '../axiosServicesLocais';
import axiosSpecialist from '../axiosServicesUsers';

async function GetSpecialist() {
  const response = await axiosSpecialist.get('admin/usuarios/v1/listar-especialistas-produto');
  return response.data.data;
}

async function GetEnterprise() {
  const response = await axiosLocal.get('admin/empreendimentos/v1');
  return response.data.data;
}

async function GetEnterpriseFilter(
  idsEmpreendimentos?: Array<string> | null,
  idsUsuariosEspecialistasProduto?: Array<string> | null,
) {
  const response = await axiosLocal.post('admin/empreendimentos/v1/listar-empreendimentos-por-ids', {
    idsEmpreendimentos: idsEmpreendimentos || null,
    idsUsuariosEspecialistasProduto: idsUsuariosEspecialistasProduto || null,
  });
  return response.data.data;
}

async function disableEnterprise(id: string) {
  const response = await axiosLocal.put(`admin/empreendimentos/v1/desativar/${id}`);
  return response;
}

async function enableEnterprise(id: string) {
  try {
    return await axiosLocal.put(`admin/empreendimentos/v1/ativar/${id}`);
  } catch (error) {
    return error;
  }
}

async function createEnterprise(
  nomeEmpreendimento: string,
  imageNome: string,
  imagemBase64: string,
  idsUsuariosVinculadosEmpreendimento: Array<string>,
) {
  try {
    const response = await axiosLocal.post('admin/empreendimentos/v1', {
      nomeEmpreendimento,
      imagem: {
        nome: imageNome,
        imagemBase64,
      },
      idsUsuariosVinculadosEmpreendimento,
    });
    return response.data.data;
  } catch (error) {
    throw new Error('Erro');
  }
}

async function updateEnterprise(
  idEnterprise: string,
  nomeEmpreendimento: string,
  imageNome: string,
  imagemBase64: string,
  idsUsuariosVinculadosEmpreendimento: Array<string>,
) {
  const response = await axiosLocal.put(`admin/empreendimentos/v1/${idEnterprise}`, {
    nomeEmpreendimento,
    imagem: !imagemBase64 ? null : {
      nome: imageNome,
      imagemBase64,
    },
    idsUsuariosVinculadosEmpreendimento,
  });
  return response.data.data;
}

export default {
  GetSpecialist,
  createEnterprise,
  GetEnterprise,
  disableEnterprise,
  enableEnterprise,
  updateEnterprise,
  GetEnterpriseFilter,
};
